module.exports = __webpack_public_path__ + "img/yy (2).cb7eca84.png";